import {
  customElement,
  FASTElement,
  Observable,
  observable,
  Splice,
} from '@microsoft/fast-element';
import { SideMenuTemplate as template } from './side-menu.template';
import { SideMenuStyles as styles } from './side-menu.styles';
import { IStructuredChatService } from '../../../services/structured-chat.service';
import { IRightMenuService } from '../../../services/right-menu.service';
import { IUserService } from '../../../services/user.service';
import { INavigationService } from '../../../services/navigation.service';

const name = 'side-menu';

@customElement({
  name,
  template,
  styles,
})
export class SideMenu extends FASTElement {
  @IStructuredChatService structuredChatService: IStructuredChatService;
  @IRightMenuService rightMenuService: IRightMenuService;
  @IUserService userService: IUserService;
  @observable isUserModalOpened: boolean;
  private notifier1: any;
  private handler1: any;
  // Temp code to be removed - Conditionally render Knowledge Block if content is available
  @INavigationService navigationService: INavigationService;

  connectedCallback() {
    super.connectedCallback();
    this.isUserModalOpened = false;
    this.userModalListener();
  }

  private userModalListener() {
    const _this = this;
    this.notifier1 = Observable.getNotifier(this.rightMenuService);
    this.handler1 = {
      handleChange(source: any, splices: Splice[]) {
        _this.isUserModalOpened = source.userModalVisibility;
      },
    };
    this.notifier1.subscribe(this.handler1, 'userModalVisibility');
  }

  public openStructuredChat() {
    this.structuredChatService.openStructuredChat();
  }

  public openUserModal() {
    this.rightMenuService.openUserModal();
  }

  public openKnowledgeBlockModal() {
    this.rightMenuService.openKnowledgeBlockModal();
  }
}
